import React from 'react'
import ListBox from 'components/ListBox'
import ListRow from 'components/ListRow'
import RouteAdminFeaturesGroupFeaturesQuery from './features.query'
import ToggleFeatureForGroupMutation from 'components/mutations/ToggleFeatureForGroup'
import { Query } from 'react-apollo'
import { SwitchInput } from 'stylist'

const RouteAdminFeaturesGroupFeatures = ({
  match: {
    params: { groupId }
  }
}) => (
  <Query
    query={RouteAdminFeaturesGroupFeaturesQuery}
    variables={{ groupId }}
    fetchPolicy="cache-and-network"
  >
    {({ loading, data: { features, group } }) => (
      <ListBox>
        {loading ? (
          <ListBox.Loader />
        ) : (
          features.map(({ id, enabled: globallyEnabled, name }) => (
            <ListBox.Item hover key={id}>
              <ListRow templateColumns="1fr auto">
                <ListRow.Cell>
                  <strong>{name}</strong>
                </ListRow.Cell>
                <ListRow.Cell actions>
                  <ToggleFeatureForGroupMutation group={group}>
                    {({ toggleFeatureForGroup }) => (
                      <SwitchInput
                        id={name}
                        checked={
                          globallyEnabled || group.features.includes(name)
                        }
                        label={
                          globallyEnabled || group.features.includes(name)
                            ? 'On'
                            : 'Off'
                        }
                        disabled={globallyEnabled}
                        onChange={e =>
                          toggleFeatureForGroup({
                            name,
                            enabled: e.target.checked
                          })
                        }
                      />
                    )}
                  </ToggleFeatureForGroupMutation>
                </ListRow.Cell>
              </ListRow>
            </ListBox.Item>
          ))
        )}
      </ListBox>
    )}
  </Query>
)

export default RouteAdminFeaturesGroupFeatures



// WEBPACK FOOTER //
// ./src/routes/admin/features/group/features.js